<template>
    <div>
        <limitless-page-header
            :sub-title="(this.invoice ? this.invoice.ocr : '')"
        ></limitless-page-header>

        <div v-if="!initialized && busy_loading" class="content">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div class="content" v-else-if="!not_found && invoice">
            <div class="row">
                <div class="col-auto flex-grow-1">
                    <form @submit.prevent="saveInvoice">
                        <ValidationObserver ref="invoiceform">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="font-weight-semibold">Typ: {{ (invoice.InvoiceType === 2 ? 'KREDITFAKTURA' : 'FAKTURA') }}</div>
                                            <div class="font-weight-semibold">Fakturanummer: {{ invoice.InvoiceID }}</div>
                                            <div class="font-weight-semibold">OCR: {{ invoice.ocr }}</div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div>
                                                <span class="font-weight-semibold">Order: </span>
                                                <router-link :to="{ name: 'cardorders.edit', params: { id: invoice.OrderID }}">{{ invoice.OrderID }}</router-link>
                                            </div>
                                            <div>
                                                <span class="font-weight-semibold">Kund: </span>
                                                <router-link :to="{ name: 'customers.edit', params: { id: invoice.customer.CustomerID }}">{{ invoice.customer.CompanyName }} ({{ invoice.customer.CustomerID }})</router-link>
                                            </div>
                                            <div v-if="invoice.source_invoice_id">
                                                <span class="font-weight-semibold">Ursprungsfaktura: </span>
                                                <router-link :to="{ name: 'invoice.edit', params: { id: invoice.source_invoice_id }}">{{ invoice.source_invoice_id }}</router-link>
                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div><span class="font-weight-semibold">Fakturadatum: </span>{{ invoice.InvoiceDate }}</div>
                                            <div><span class="font-weight-semibold">Förfallodatum: </span>{{ invoice.ExpireDate }}</div>
                                            <div v-if="invoice.unpaid_amount !== 0">
                                                <span class="font-weight-semibold">Kvar att betala: </span>
                                                <span>{{ formatNumber(invoice.unpaid_amount) }} {{ (invoice.currency ? invoice.currency.CurrencyShort : (invoice.customer.currency ? invoice.customer.currency.CurrencyShort : 'SEK?')) }}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 text-right">
                                            <div>
                                                <div v-if="invoice.isPaid || invoice.unpaid_amount === 0" class="badge badge-success font-size-lg"><i class="icon-check mr-1"></i>Betald</div>
                                                <div v-else-if="invoice.paid_amount !== 0" class="badge badge-danger font-size-lg">Delbetald</div>
                                                <div v-else class="badge badge-danger font-size-lg">Ej Betald</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-2 col-form-label font-weight-semibold">Osäker fodring</div>
                                        <div class="col-xl-10" style="padding-top: calc(0.4375rem + 1px);">
                                            <div class="form-group">
                                                <div class="custom-control custom-radio custom-control-inline mr-4">
                                                    <input id="chk-isActive-0" name="isInsecure" type="radio" class="custom-control-input" v-model="invoice.isInsecure" :value="0">
                                                    <label for="chk-isActive-0" class="custom-control-label">Nej</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline mr-4">
                                                    <input id="chk-isActive-1" name="isInsecure" type="radio" class="custom-control-input" v-model="invoice.isInsecure" :value="1">
                                                    <label for="chk-isActive-1" class="custom-control-label">Osäker fodring</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline mr-4">
                                                    <input id="chk-isActive-2" name="isInsecure" type="radio" class="custom-control-input" v-model="invoice.isInsecure" :value="2">
                                                    <label for="chk-isActive-2" class="custom-control-label">Kundförlust/Konkurs</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-2 col-form-label font-weight-semibold">Flaggor</div>
                                        <div class="col-xl-5" style="padding-top: calc(0.4375rem + 1px);">
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input id="chk-isInternal" name="isInternal" type="checkbox" class="custom-control-input" v-model="invoice.isInternal" :true-value="1" :false-value="0">
                                                    <label for="chk-isInternal" class="custom-control-label">Internfaktura</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-2 col-form-label font-weight-semibold">Påminnelser</div>
                                        <div class="col-xl-5" style="padding-top: calc(0.4375rem + 1px);">
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input id="chk-RemindDate" name="RemindDate" type="checkbox" class="custom-control-input" :checked="invoice.isReminded >= 1 && !!(invoice.RemindDate)" disabled>
                                                    <label for="chk-RemindDate" class="custom-control-label">P1</label>
                                                </div>
                                                <div
                                                    v-if="invoice.isReminded >= 1 && invoice.RemindDate"
                                                    class="d-inline"
                                                >({{ invoice.RemindDate }})</div>
                                                <div
                                                    v-else-if="invoice.unpaid_amount > 0"
                                                    class="d-inline"
                                                >
                                                    <a href="#" @click="createReminder">Skapa påminnelse</a>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input id="chk-RemindDate2" name="RemindDate2" type="checkbox" class="custom-control-input" :checked="invoice.isReminded >= 2 && !!(invoice.RemindDate2)" disabled>
                                                    <label for="chk-RemindDate2" class="custom-control-label">P2</label>
                                                </div>
                                                <div
                                                    v-if="invoice.isReminded >= 2 && invoice.RemindDate2"
                                                    class="d-inline"
                                                >({{ invoice.RemindDate2 }})</div>
                                                <div
                                                    v-else-if="invoice.isReminded >= 1 && invoice.RemindDate && invoice.unpaid_amount > 0"
                                                    class="d-inline"
                                                >
                                                    <router-link :to="{ name: 'invoice.preview', query: { invoice_ids: [invoice.InvoiceID], reminder: true } }">Skapa påminnelse</router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-5" style="padding-top: calc(0.4375rem + 1px);">
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input id="chk-CallMade" name="SentToKronofogden" type="checkbox" class="custom-control-input" v-model="invoice.call_made">
                                                    <label for="chk-CallMade" class="custom-control-label">Samtal</label>
                                                </div>
                                                <div
                                                    v-if="invoice.call_made && invoice.RemindDate3"
                                                    class="d-inline"
                                                >({{ invoice.RemindDate3 }})</div>
                                            </div>
                                            <div class="form-group">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input id="chk-SentToKronofogden" name="SentToKronofogden" type="checkbox" class="custom-control-input" v-model="invoice.SentToKronofogden" :true-value="1" :false-value="0">
                                                    <label for="chk-SentToKronofogden" class="custom-control-label">Kronofogden</label>
                                                </div>
                                                <div
                                                    v-if="invoice.SentToKronofogden && invoice.KronofogdenDate"
                                                    class="d-inline"
                                                >({{ invoice.KronofogdenDate }})</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-2 col-form-label font-weight-semibold">Intern kommentar</div>
                                        <div class="col-xl-10">
                                            <div class="form-group">
                                                <elastic-textarea
                                                    v-model="invoice.InternalComment"
                                                    class="form-control"
                                                    :rows="3"
                                                ></elastic-textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="invoice.CreditComment"
                                        class="row"
                                    >
                                        <div class="col-xl-2 col-form-label font-weight-semibold">Kredit-kommentar</div>
                                        <div class="col-xl-10">
                                            <div class="form-group">
                                                <elastic-textarea
                                                    v-model="invoice.CreditComment"
                                                    class="form-control"
                                                    :rows="3"
                                                    disabled
                                                ></elastic-textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card border-warning">
                                        <div class="card-header bg-warning text-white header-elements-inline">
                                            <h6 class="card-title">ENDAST SUPERADMIN</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input id="chk-isAccepted" name="isAccepted" type="checkbox" class="custom-control-input" v-model="invoice.isAccepted">
                                                <label for="chk-isAccepted" class="custom-control-label">Godkänd/Låst</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer d-flex justify-content-between">
                                    <limitless-button @click="showModalCredit" btn-class="btn-warning" icon="icon-database-refresh">Skapa kredit</limitless-button>
                                    <limitless-button ref="btnsaveinvoice" @click="saveInvoice" icon="icon-floppy-disk" :busy="busy_saving">Spara</limitless-button>
                                </div>
                            </div>
                        </ValidationObserver>
                    </form>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="card-title">Fakturarader</h5>
                        </div>
                        <div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Art.no.</th>
                                        <th>Beskrivning</th>
                                        <th class="text-right">Antal</th>
                                        <th class="text-right">Á-pris</th>
                                        <th class="text-right">Moms</th>
                                        <th class="text-right">Belopp</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, i_index) in invoice.items"
                                        :key="'item-' + i_index"
                                    >
                                        <td>{{ (item.product_id ? 'P' + item.product_id : item.card_series_id) }}</td>
                                        <td>{{ item.description }}</td>
                                        <td class="text-right">{{ item.quantity }}</td>
                                        <td class="text-right">{{ formatNumber(item.price) }}</td>
                                        <td class="text-right">{{ item.vat_percent }} %</td>
                                        <td class="text-right">{{ formatNumber(item.quantity * item.price, 2) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="4"></th>
                                        <th class="text-right">Delsumma</th>
                                        <th class="text-right">{{ formatNumber(invoice.InvoiceSum) }}</th>
                                    </tr>
                                    <tr v-if="invoice.InvoiceVAT6 < 0 || invoice.InvoiceVAT6 > 0">
                                        <th colspan="4"></th>
                                        <th class="text-right">Moms 6%</th>
                                        <th class="text-right">{{ formatNumber(invoice.InvoiceVAT6) }}</th>
                                    </tr>
                                    <tr v-if="invoice.InvoiceVAT12 < 0 || invoice.InvoiceVAT12 > 0">
                                        <th colspan="4"></th>
                                        <th class="text-right">Moms 12%</th>
                                        <th class="text-right">{{ formatNumber(invoice.InvoiceVAT12) }}</th>
                                    </tr>
                                    <tr v-if="invoice.InvoiceVAT25 < 0 || invoice.InvoiceVAT25 > 0">
                                        <th colspan="4"></th>
                                        <th class="text-right">Moms 25%</th>
                                        <th class="text-right">{{ formatNumber(invoice.InvoiceVAT25) }}</th>
                                    </tr>
                                    <tr v-if="invoice.InvoiceSumFull !== round(invoice.InvoiceSumFull)">
                                        <th colspan="4"></th>
                                        <th class="text-right">Avrundning</th>
                                        <th class="text-right">{{ formatNumber(round(invoice.InvoiceSumFull) - invoice.InvoiceSumFull) }}</th>
                                    </tr>
                                    <tr>
                                        <th colspan="4"></th>
                                        <th class="text-right">ATT BETALA ({{ (invoice.currency ? invoice.currency.CurrencyShort : (invoice.customer.currency ? invoice.customer.currency.CurrencyShort : 'SEK?')) }}):</th>
                                        <th class="text-right">{{ formatNumber(round(invoice.InvoiceSumFull)) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white header-elements-inline">
                            <h5 class="card-title">Betalningar</h5>
                            <div class="header-elements">
                                <button type="button" @click="showPaymentForm" class="btn btn-light">Registrera betalning</button>
                            </div>
                        </div>
                        <div
                            v-if="invoice.payments.length > 0"
                        >
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Datum</th>
                                        <th>Källa</th>
                                        <th>Käll-ID</th>
                                        <th>Referens</th>
                                        <th>Kommentar</th>
                                        <th class="text-right">Belopp</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(payment, p_index) in invoice.payments"
                                        :key="'payment-' + p_index"
                                    >
                                        <td>{{ payment.PaymentID }}</td>
                                        <td>{{ payment.PaymentDate.substring(0, 10) }}</td>
                                        <td>{{ payment.Source }}</td>
                                        <td>{{ payment.SourceID }}</td>
                                        <td>{{ payment.Reference }}</td>
                                        <td>
                                            <div>{{ payment.Comment }}</div>
                                            <div>{{ payment.InternalNote }}</div>
                                        </td>
                                        <td class="text-right">{{ formatNumber(payment.Amount, 2) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="5"></th>
                                        <th class="text-right">TOTALT:</th>
                                        <th class="text-right">{{ formatNumber(invoice.paid_amount, 2) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div
                            v-else
                            class="card-body"
                        >
                            <i>Inga betalningar</i>
                        </div>
                    </div>

                    <div
                        v-if="Array.isArray(invoice.credits) && invoice.credits.length > 0"
                        class="card"
                    >
                        <div class="card-header bg-white header-elements-inline">
                            <h5 class="card-title">Kreditfakturor</h5>
                        </div>
                        <div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>OCR</th>
                                        <th>Fakturadatum</th>
                                        <th>Förfallodatum</th>
                                        <th>Kommentar</th>
                                        <th class="text-right">Fakturabelopp</th>
                                        <th class="text-right">Skuld</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(credinv, c_index) in invoice.credits"
                                        :key="'credit-' + c_index"
                                    >
                                        <td>
                                            <router-link :to="{ name: 'invoice.edit', params: { id: credinv.InvoiceID } }">{{ credinv.ocr }}</router-link>
                                        </td>
                                        <td>{{ credinv.InvoiceDate }}</td>
                                        <td>{{ credinv.ExpireDate }}</td>
                                        <td>{{ credinv.CreditComment }}</td>
                                        <td class="text-right">{{ formatNumber(credinv.InvoiceSumFull, 2) }} {{ (credinv.CurrencyShort ? credinv.CurrencyShort : 'SEK') }}</td>
                                        <td class="text-right">{{ formatNumber((credinv.isPaid ? 0 : credinv.unpaid_amount), 2) }} {{ (credinv.CurrencyShort ? credinv.CurrencyShort : 'SEK') }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="4"></th>
                                        <th class="text-right">TOTALT:</th>
                                        <th class="text-right">{{ formatNumber(invoice.credits.reduce( function(a, b){
                                            return a + b.unpaid_amount;
                                        }, 0)) }} {{ (invoice.CurrencyShort ? invoice.CurrencyShort : 'SEK') }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div
                        class="card"
                        v-if="invoice.FortnoxInvoiceID"
                    >
                        <div
                            class="card-header bg-white"
                            @click.prevent="toggleFortnox"
                            style="cursor: pointer;"
                        >
                            <h5 class="card-title">
                                <a class="text-body collapsed">Fortnox</a>
                            </h5>
                            <span>Klicka för att visa/dölja</span>
                        </div>

                        <div id="collapse-item-default1" class="collapse" :class="{ 'show': show_fortnox }">
                            <div class="card-body">
                                <div v-if="busy_fortnox">
                                    <i class="icon-spinner2 spinner"></i>
                                </div>
                                <div v-else-if="fortnox_data">
                                    <pre v-if="fortnox_data.invoice" v-html="fortnox_data.invoice"></pre>
                                    <pre
                                        v-for="(payment, p_index) in fortnox_data.payments"
                                        :key="'pre-ip-' + p_index"
                                        v-html="payment"
                                        class="mt-3"
                                    ></pre>
                                </div>
                                <div v-else>
                                    <i class="text-danger">Ingen data</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="col-auto"
                    style="min-width: 490px;"
                >
                    <div
                        v-if="invoice.pdf"
                    >
                        <iframe name="InvoicePDF" width="490" height="700" :src="invoice.pdf"></iframe>
                    </div>
                    <div
                        v-if="invoice.isReminded > 0 && invoice.pdf_reminder"
                    >
                        <iframe name="ReminderPDF" width="490" height="700" :src="invoice.pdf_reminder"></iframe>
                    </div>
                </div>

                <b-modal id="modal-credit-invoice" size="lg" @ok="createCredit" title="Skapa kredit">
                    <button class="btn btn-light" @click="creditAll">Kreditera allt</button>
                    <ValidationObserver ref="creditform">
                        <form v-if="credit" @submit="createCredit">
                            <table class="table table-xs">
                                <thead>
                                    <tr>
                                        <th>Art.no.</th>
                                        <th>Beskrivning</th>
                                        <th>Antal</th>
                                        <th class="text-right">Á-pris</th>
                                        <th class="text-right">Moms</th>
                                        <th class="text-right">Belopp</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, r_index) in credit.items"
                                        :key="'ci-' + r_index"
                                    >
                                        <td>{{ (item.product_id ? 'P' + item.product_id : item.card_series_id) }}</td>
                                        <td>{{ item.description }}</td>
                                        <td>
                                            <input-with-validation
                                                :vid="'items.' + r_index + '.quantity'"
                                                label="Antal"
                                                v-model="item.quantity"
                                                type="number"
                                                min="0"
                                                :max="item.max_credit_quantity"
                                                hide-label
                                                compact
                                                :rules="{ max_value: item.max_credit_quantity, min_value: 0 }"
                                                no-bottom-margin
                                            >
                                                <template #input-group-append>
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">
                                                            av {{ item.max_credit_quantity }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </input-with-validation>
                                        </td>
                                        <td class="text-right">{{ formatNumber(item.price) }}</td>
                                        <td class="text-right">{{ item.vat_percent }} %</td>
                                        <td class="text-right">{{ formatNumber(item.quantity * item.price, 2) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="5" class="text-right">TOTALT BELOPP:</th>
                                        <th class="text-right">{{ formatNumber(creditTotal) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                            <textarea-with-validation
                                label="Kommentar"
                                v-model="credit.CreditComment"
                                rules="required"
                            ></textarea-with-validation>
                        </form>
                    </ValidationObserver>
                    <template #modal-footer="{ cancel, ok }">
                        <button
                            type="button"
                            class="btn btn-light"
                            @click="cancel"
                        >
                            Avbryt
                        </button>
                        <limitless-button
                            ref="btncreatecredit"
                            type="button"
                            @click.prevent="ok"
                            :busy="busy_credit"
                        >
                            Skapa
                        </limitless-button>
                    </template>
                </b-modal>
            </div>

            <b-modal id="modal_payment" @ok="registerPayment" title="Registrera betalning">
                <ValidationObserver ref="paymentform">
                    <form @submit="registerPayment">
                        <input-with-validation
                            vid="Amount"
                            label="Belopp"
                            v-model="payment.Amount"
                            rules="required"
                        ></input-with-validation>
                        <ValidationProvider vid="PaymentDate" name="Datum" rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Datum<span class="text-danger">*</span></label>
                                <v-date-picker v-model="payment.PaymentDate" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                    <template v-slot="{ inputValue, togglePopover }">
                                        <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{'has-validation-error':(!!errors[0])}">
                                    </template>
                                </v-date-picker>
                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                        <textarea-with-validation
                            vid="Comment"
                            label="Kommentar"
                            v-model="payment.Comment"
                            rules="required"
                        ></textarea-with-validation>
                    </form>
                </ValidationObserver>
                <template #modal-footer="{ cancel, ok }">
                    <button
                        type="button"
                        class="btn btn-light"
                        @click="cancel"
                    >
                        Avbryt
                    </button>
                    <limitless-button
                        ref="btnsavepayment"
                        type="button"
                        @click.prevent="ok"
                        :busy="busy_payment"
                    >
                        Spara
                    </limitless-button>
                </template>
            </b-modal>
        </div> <!-- /content -->
        <div class="content" v-else-if="not_found">
            <i>Fakturan finns inte</i>
        </div>
        <div class="content" v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import ElasticTextarea from '@components/ElasticTextarea.vue';
import { formatDateTime, formatNumber, round } from '@services/Helpers';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import TextareaWithValidation from '@components/Form/TextareaWithValidation.vue';

export default {
    components: {
        TextareaWithValidation,
        VDatePicker,
        InputWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
        ElasticTextarea,
    },
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_saving: false,
        busy_payment: false,
        busy_credit: false,
        busy_fortnox: false,
        invoice: null,
        credit: null,
        show_fortnox: null,
        fortnox_data: null,
        payment: {
            Amount: '',
            PaymentDate: '',
            Comment: '',
        },
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        formatNumber,
        formatDateTime,
        round,
        init() {
            this.getInvoice();
        },
        getInvoice() {
            this.busy_loading = true;
            apiClient.get('/vue/invoices/' + this.id)
                .then((response) => {
                    this.invoice = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy_loading = false;
                });
        },
        async saveInvoice() {
            const isValid = await this.$refs.invoiceform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/invoices/' + this.id, this.invoice)
                    .then((response) => {
                        this.invoice = response.data;
                    }).catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.invoiceform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveinvoice.triggerFailed();
                    }).finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        showPaymentForm() {
            const date = new Date();
            this.payment = {
                Amount: '',
                PaymentDate: date.toISOString().substring(0, 10),
                Comment: '',
            };
            this.$bvModal.show('modal_payment');
        },
        async registerPayment() {
            const isValid = await this.$refs.paymentform.validate();
            if (isValid) {
                this.busy_payment = true;
                await apiClient.post('/vue/invoices/payments', { ...this.payment, InvoiceID: this.id })
                    .then(() => {
                        this.getInvoice();
                    }).catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.paymentform.setErrors(parsederror);
                        }
                        this.$refs.btnsavepayment.triggerFailed();
                    }).finally(() => {
                        this.busy_payment = false;
                    });
            }
        },
        async createReminder() {
            let doDelete = false;
            await this.$swal({
                text: 'Är du säker att du vill skapa en påminnelse?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, skapa en påminnelse!',
            }).then((result) => {
                if (result.isConfirmed) {
                    doDelete = true;
                }
            });
            if (doDelete) {
                this.$router.push({
                    name: 'invoice.preview',
                    query: {
                        invoice_ids: [this.id],
                        reminder: true,
                    },
                });
            }
        },
        showModalCredit() {
            let totItemsLeft = 0;
            this.invoice.items.forEach((item) => {
                totItemsLeft += item.max_credit_quantity;
            });

            if (totItemsLeft === 0) {
                this.$swal({
                    text: 'Denna faktura är redan helt krediterad.',
                    icon: 'warning',
                });
            } else {
                const credit = {
                    source_invoice_id: this.invoice.InvoiceID,
                    items: [],
                    CreditComment: '',
                };
                this.invoice.items.forEach((item) => {
                    credit.items.push({
                        ...item,
                        id: null,
                        source_invoice_item_id: item.id,
                        price: 0 - item.price,
                        vat: 0 - item.vat,
                        quantity: 0,
                    });
                });

                this.credit = credit;
                this.$bvModal.show('modal-credit-invoice');
            }
        },
        creditAll() {
            this.credit.items.forEach((item) => {
                item.quantity = item.max_credit_quantity;
            });
        },
        async createCredit(event) {
            event.preventDefault();
            const isValid = await this.$refs.creditform.validate();
            if (isValid) {
                const totalQuantity = this.credit.items.reduce((a, b) => a + b.quantity, 0);

                if (totalQuantity > 0) {
                    this.busy_credit = true;
                    await apiClient.post('/vue/invoices/credit', this.credit)
                        .then(async (response) => {
                            await this.$router.push({
                                name: 'invoice.preview',
                                query: {
                                    invoice_ids: [
                                        response.data.InvoiceID,
                                    ],
                                },
                            });
                        }).catch((error) => {
                            const parsederror = getError(error);
                            if (typeof parsederror === 'object') {
                                this.$refs.creditform.setErrors(parsederror);
                            }
                            this.$refs.btncreatecredit.triggerFailed();
                        }).finally(() => {
                            this.busy_credit = false;
                        });
                } else {
                    this.$refs.creditform.setErrors({ 'items.0.quantity': ['Du måste kreditera minst 1st av någon produkt.'] });
                    this.$refs.btncreatecredit.triggerFailed();
                }
            } else {
                this.$refs.btncreatecredit.triggerFailed();
            }
        },
        toggleFortnox() {
            if (!this.show_fortnox && !this.fortnox_data) {
                this.busy_fortnox = true;
                apiClient.get('/vue/invoices/' + this.id + '/fortnox')
                    .then((response) => {
                        this.fortnox_data = response.data;
                    })
                    .finally(() => {
                        this.busy_fortnox = false;
                    });
            }

            this.show_fortnox = !this.show_fortnox;
        },
    },
    computed: {
        creditTotal() {
            let sum = 0;
            if (this.credit && this.credit.items) {
                this.credit.items.forEach((item) => {
                    sum += this.round(item.quantity * item.price, 2);
                });
            }
            return sum;
        },
    },
};

</script>
